import { MediaObject } from "@/ds/custom/MediaObject";
import { ProductImage } from "@/features/common/components/ProductImage";
import type { FC } from "react";

export interface SmallProductDisplayProps {
	productName: string;
	fcId: string;
	imageUrl: string;
	className?: string;
	onClick?: () => void;
}

export const SmallProductDisplay: FC<SmallProductDisplayProps> = props => {
	const {
		productName,
		fcId,
		imageUrl,
		onClick,
		className
	} = props;

	return (
		<MediaObject
			media={<ProductImage imageUrl={imageUrl} className={className} />}
			title={productName}
			description={fcId}
			onClick={onClick} />
	);
};
